import { render, staticRenderFns } from "./room-detail-popover.vue?vue&type=template&id=5b1d5fcb&scoped=true&"
import script from "./room-detail-popover.js?vue&type=script&lang=js&"
export * from "./room-detail-popover.js?vue&type=script&lang=js&"
import style0 from "./room-detail-popover.scss?vue&type=style&index=0&id=5b1d5fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d5fcb",
  null
  
)

export default component.exports